import axios from 'axios'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import CreateCompany from './dto/CreateCompany'
import GetCompany from './dto/GetCompany'
import {PagedCompanyResultRequestDto} from './dto/PagedCompanyResultRequestDto'
import UpdateCompany from './dto/UpdateCompany'
import GetAllCompanies from './dto/GetAllCompanies'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Company/Create`
export const URL_DELETE = `${API_URL}/Company/Delete`
export const URL_GET = `${API_URL}/Company/Get`
export const URL_GET_ALL = `${API_URL}/Company/GetPagedAll`
export const URL_UPDATE = `${API_URL}/Company/Update`
export const URL_GET_ALL_FOR_ADMIN = `${API_URL}/Company/GetPagedAllForAdmin`
export const URL_UPDATE_FOR_ADMIN = `${API_URL}/Company/UpdateForAdmin`

export function onCreateCompany(createCompany: CreateCompany): Promise<boolean> {
  return axios.post(URL_CREATE, createCompany)
}

export function onDeleteCompany(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetCompany(entityDto: EntityDto): Promise<GetCompany> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllCompanies(
  pagedFilterAndSortedRequest: PagedCompanyResultRequestDto
): Promise<PagedResultDto<GetAllCompanies>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateCompany(updateCompanyInput: UpdateCompany): Promise<boolean> {
  return axios.put(URL_UPDATE, updateCompanyInput)
}

export function onGetPagedAllCompaniesForAdmin(
  pagedFilterAndSortedRequest: PagedCompanyResultRequestDto
): Promise<PagedResultDto<GetAllCompanies>> {
  return axios.get(URL_GET_ALL_FOR_ADMIN, {params: pagedFilterAndSortedRequest})
}

export function onUpdateCompanyForAdmin(updateCompanyInput: UpdateCompany): Promise<boolean> {
  return axios.put(URL_UPDATE_FOR_ADMIN, updateCompanyInput)
}
